export default __webpack_public_path__ + "static/petnat-441c31331e32d175aa478e3d493d2f49.jpg";